import React from 'react';

const research = () => {
  return (
    <div>
      research
    </div>
  );
}

export default research;
